import { db } from './db';
import { useOfflineStore } from '../stores/offlineStore';
import { clearCache as clearApiCache, clearAssetManagementApiCache } from '../services/apiCache';
import { clearInspectionEmergencyDraft } from './inspectionEmergencyDraft';

const AM_REFERENCE_KEY_PREFIXES = [
  'assetRegister_',
  'assetTypes_',
  'assetScanContext_'
];

/**
 * Clear queued sync data and asset-management offline caches on logout.
 * Prevents cross-user data leakage on shared devices.
 *
 * @param {{ clearEmergencyDrafts?: boolean }} [options]
 *   clearEmergencyDrafts defaults true (intentional logout).
 *   Pass false on forced session expiry so the same user can recover an inspection draft.
 */
export async function clearOfflineDataOnLogout(options = {}) {
  const { clearEmergencyDrafts = true } = options;
  try {
    const tableNames = [
      'syncQueue',
      'files',
      'goodCalls',
      'closeCalls',
      'ramsDocuments',
      'assetRegisterRecords',
      'assetDailyChecks'
    ];

    await db.transaction('rw', tableNames.map((name) => db[name]), async () => {
      for (const name of tableNames) {
        if (db[name]) {
          await db[name].clear();
        }
      }
    });

    await db.referenceData
      .filter((row) => AM_REFERENCE_KEY_PREFIXES.some((prefix) => row.key?.startsWith(prefix)))
      .delete();

    await clearAssetManagementApiCache();
    await clearApiCache();

    if (clearEmergencyDrafts) {
      await clearInspectionEmergencyDraft();
    }

    useOfflineStore.getState().setPendingSyncCount(0);
  } catch (err) {
    console.warn('[clearOfflineDataOnLogout] Failed:', err);
  }
}
